import React, { Component } from 'react'
import Grid from "../../components/grid";
import { connect } from "react-redux";
import './style.scss';
import Select from 'react-select';
import { getPPDOverview, GetEins } from '../../store/actions';
import { groupBy, has } from 'lodash';
import { format, subDays, subMonths } from 'date-fns';
import { numValueFormatter } from '../../utils/helpers';
import { selectStyles } from '../../components/ourSelect/SelectStyles';
import { b } from 'react-dom-factories';
import ExportHeader from '../../components/grid/ExportHeader';

class PPDOverview extends Component {

    currentMonth = format(new Date(), "MMM yyyy");
    lastMonth = format(subMonths(new Date(), 1), "MMM yyyy");
    currentYear = new Date().getFullYear();

    state = {
        einList: [],
        columnDefs: [],
        isSummary: true,
        loading: true,
        groupDefaultExpanded: 0,
        groupTotalRow: null,
    };

    last30Days = () => {
        let days = [];
        for (let i = 1; i < 30; i++) {
            let date = format(subDays(new Date(), i), "MM/dd/yyyy");
            days.push(date);
        };
        return days;
    };

    summaryColumnDefs = [
        {
            headerName: "Department",
            field: "department",
            rowGroup: true,
            hide: true
        },
        {
            headerName: "PPD Budget",
            field: "budget",
            aggFunc: "sum",
            width: 130,
            valueFormatter: params => {
                return params.node.rowPinned ? params.data.budget : numValueFormatter(params.value);
            }
        },
        {
            headerName: "Last Month",
            field: `${this.lastMonth}.ppd`,
            aggFunc: "sum",
            width: 130,
            valueFormatter: params => {
                return params.node.rowPinned ? params.data[`${this.lastMonth}.ppd`] : numValueFormatter(params.value);
            },
            cellClassRules: {
                'green-background': ({ node, value }) => {
                    if (node.rowPinned) return false;
                    let { aggData } = node;
                    let { budget } = aggData;
                    return budget && value / budget < 1.1;
                },
                'light-red-background': ({ node, value }) => {
                    if (node.rowPinned) return false;
                    let { aggData } = node;
                    let { budget } = aggData;
                    return budget && value / budget >= 1.1 && value / budget < 1.5;
                },
                'dark-red-background': ({ node, value }) => {
                    if (node.rowPinned) return false;
                    let { aggData } = node;
                    let { budget } = aggData;
                    return budget && value / budget >= 1.5;
                }
            }
        },
        {
            headerName: "Current MTD",
            field: `${this.currentMonth}.ppd`,
            aggFunc: "sum",
            width: 130,
            valueFormatter: params => {
                return params.node.rowPinned ? params.data[`${this.currentMonth}.ppd`] : numValueFormatter(params.value);
            }
        },
        {
            headerName: "MTD VS Budget",
            field: `${this.currentMonth}.ppdVSBudget`,
            aggFunc: "avg",
            width: 150,
            valueFormatter: params => params.node.rowPinned ? "" : numValueFormatter(params.value, "percent")
        },
        {
            headerName: "YTD",
            field: "YTD.ppd",
            aggFunc: "sum",
            width: 85,
            valueFormatter: params => {
                return params.node.rowPinned ? "" : numValueFormatter(params.value);
            }
        },
        {
            headerName: "YTD VS Budget",
            field: "YTD.ppdVSBudget",
            aggFunc: "avg",
            width: 150,
            valueFormatter: params => params.node.rowPinned ? "" : numValueFormatter(params.value, "percent")
        },
        {
            //headerName: "Export",
            field: "",
            headerComponent: ExportHeader,
            width: 85,
            headerComponentParams: {
                //displayName: "Export Report",
                fileName: `PPD Overview - ${this.currentMonth}.xlsx`,
            },
        }
    ];
    detailColumnDefs = [
        {
            headerName: "Summary",
            children: [
                {
                    headerName: "Department",
                    field: "department",
                    rowGroup: true,
                    pinned: 'left'

                },
                {
                    headerName: "Job",
                    field: "jobName",
                },
                {
                    headerName: "Avg Rate Last 30 Days",
                    field: "avgRate",
                    aggFunc: "sum",
                    cellRenderer: params => this.boldGroupRenderer(params),
                    cellRendererParams: {
                        formattingStyle: "currency",
                        currency: "USD"
                    }
                }, {
                    headerName: "Avg Reg Rate last 30",
                    field: "avgRegRate",
                    aggFunc: "sum",
                    cellRenderer: params => this.boldGroupRenderer(params),
                    cellRendererParams: {
                        formattingStyle: "currency",
                        currency: "USD"
                    }
                },
                {
                    headerName: "PPD Budget",
                    field: "budget",
                    aggFunc: "sum",
                    cellRenderer: params => this.boldGroupRenderer(params),
                },
                {
                    headerName: "Last Month",
                    field: `${this.lastMonth}.ppd`,
                    aggFunc: "sum",
                    cellRenderer: params => this.boldGroupRenderer(params),
                },
                {
                    headerName: "Current MTD",
                    field: `${this.currentMonth}.ppd`,
                    aggFunc: "sum",
                    cellRenderer: params => this.boldGroupRenderer(params),
                },
                {
                    headerName: "MTD vs Budget",
                    field: `${this.currentMonth}.ppdVSBudget`,
                    aggFunc: "avg",
                    cellRenderer: params => this.boldGroupRenderer(params),
                    cellRendererParams: {
                        formattingStyle: "percent"
                    }
                },
                {
                    headerName: "PPD YTD",
                    field: "YTD.ppd",
                    aggFunc: "sum",
                    cellRenderer: params => this.boldGroupRenderer(params),
                },
                {
                    headerName: "YTD vs Budget",
                    field: "YTD.ppdVSBudget",
                    aggFunc: "avg",
                    cellRenderer: params => this.boldGroupRenderer(params),
                    cellRendererParams: {
                        formattingStyle: "percent"
                    }
                }
            ]
        },
        {
            headerName: "Dailies",
            children:
                this.last30Days().map(el => {
                    return {
                        headerName: el,
                        field: `${el}.ppd`,
                        aggFunc: "sum",
                        cellRenderer: params => this.boldGroupRenderer(params),
                    };
                })
        }
    ];

    boldGroupRenderer = params => {
        let value = numValueFormatter(params.value, params.formattingStyle, params.currency);
        if (value === "NaN" || value === "NaN%" || value === "$NaN") {
            value = "N/A";
        };
        return <span>{params.node.isExpandable() ? <b>{value}</b> : value}</span>
    };

    onGridReady = params => {
        this.gridApi = params.api;
    };

    handleExport = () => {
        if (this.gridApi) {
            this.gridApi.exportGridToExcel({
                fileName: `PPD Overview - ${this.currentMonth}.xlsx`,
            });
        }
    };


    autoGroupColumnDef = {
        headerName: "Department",
        cellRenderer: (params) => <span>{params.value}</span>,
        cellRendererParams: {
            suppressCount: true,
        }
    };

    async componentDidMount() {
        let isMultiEIN = has(this.props.ClientDataReducer, "isMultiEIN") ? this.props.ClientDataReducer.isMultiEIN : this.props.UserReducer.companyDetails.isMultiEIN;
        if (isMultiEIN && (!this.props.EINS || !this.props.EINS.length)) {
            await this.props.GetEins(this.props.UserReducer.companyId);
        };
        let einList = [];
        let selectedEIN;
        if (isMultiEIN) {
            einList = this.props.EINS.records.map(el => ({ ...el, value: el.companyEIN, label: el.companyEIN }));
            selectedEIN = einList[0];
        };
        await this.props.getPPDOverview({ companyId: this.props.UserReducer.companyId, companyShortName: this.props.UserReducer.company.toUpperCase() });
        let overviewData = isMultiEIN ? (this.props.PPD_OVERVIEW && this.props.PPD_OVERVIEW[selectedEIN.companyEIN] || []) : this.props.PPD_OVERVIEW;
        this.pinnedTopRowData = [{
            budget: "Census: ",
            [`${this.lastMonth}.ppd`]: overviewData[0][`${this.lastMonth}`].census,
            [`${this.currentMonth}.ppd`]: overviewData[0][`${this.currentMonth}`].census,
        }]
        this.setState({ einList, isMultiEIN, selectedEIN, columnDefs: this.summaryColumnDefs, rowData: overviewData || [], loading: false });
    };

    async componentDidUpdate(prevProps, prevState) {
        let { isSummary, isMultiEIN, selectedEIN } = this.state;
        let { isSummary: prevSummary } = prevState;
        if (isSummary !== prevSummary) {
            if (isSummary) {
                this.setState({ columnDefs: this.summaryColumnDefs, });
            } else {
                this.setState({ columnDefs: this.detailColumnDefs, });
            };
        };
    };

    toggleDetails = () => {
        let { isSummary } = this.state;
        this.setState({ isSummary: !isSummary }, () => {
            // After state update, force complete grid redraw
            if (this.gridApi) {
                setTimeout(() => {
                    this.gridApi.redrawRows();
                    this.gridApi.refreshHeader();
                }, 50);
            }
        });
    };

    onSelectEIN = selected => {
        let rowData = this.props.PPD_OVERVIEW[selected.companyEIN];
        this.setState({ rowData, selectedEIN: selected });
    };

    render() {
        const { rowData, isMultiEIN, loading, columnDefs, einList, selectedEIN, isSummary } = this.state;
        return (
            <div >
                <div className="shadow_white_box full-box mt-0">
                    <div className="ppd-header">
                        <h4 className="ppd-title">PPD Overview</h4>
                        {isMultiEIN ? (
                            <div className="ppd-ein-select">
                                <label className="ppd-ein-label">Select EIN:</label>
                                <div className="control-bar">
                                    <Select
                                        placeholder="Select EIN"
                                        options={einList}
                                        value={selectedEIN}
                                        onChange={this.onSelectEIN}
                                        styles={selectStyles}
                                    >
                                    </Select>
                                </div>
                            </div>
                        ) : ""}
                        <button className="ppd-details-btn" onClick={this.toggleDetails} disabled={loading}>
                            {loading ? <span>Loading data </span> : <span>{isSummary ? "Details..." : "Summary"}</span>}
                        </button>
                    </div>
                    <div>
                        {isSummary ?
                            <Grid
                                rowData={rowData}
                                columnDefs={columnDefs}
                                height="600px"
                                onGridReady={this.onGridReady}
                                suppressAggFuncInHeader={true}
                                autoGroupColumnDef={this.autoGroupColumnDef}
                                groupDefaultExpanded={0}
                                pinnedTopRowData={this.pinnedTopRowData}
                            >
                            </Grid> : <div></div>
                        }
                        {!isSummary ?

                            <Grid
                                rowData={rowData}
                                columnDefs={columnDefs}
                                height="600px"
                                onGridReady={this.onGridReady}
                                suppressAggFuncInHeader={true}
                                autoGroupColumnDef={this.autoGroupColumnDef}
                                groupDefaultExpanded={-1}
                            ></Grid> : <div></div>
                        }
                    </div>
                </div>
            </div>
        );
    };
};

const mapStateToProps = ({ UserReducer, PPDReducer, EINReducer, ClientDataReducer }) => {
    let { PPD_OVERVIEW } = PPDReducer;
    let { EINS } = EINReducer;
    return { UserReducer, EINS, ClientDataReducer, PPD_OVERVIEW };
};
export default connect(mapStateToProps, { getPPDOverview, GetEins })(PPDOverview);

